 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Boyuk~Giganje~Home~PrivacyPolicy~TermOfService":"Boyuk~Giganje~Home~PrivacyPolicy~TermOfService","Boyuk~Giganje":"Boyuk~Giganje","Boyuk":"Boyuk","Giganje":"Giganje","Home":"Home","PrivacyPolicy":"PrivacyPolicy","TermOfService":"TermOfService","NotFound":"NotFound","polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom"}[chunkId]||chunkId) + "." + {"Boyuk~Giganje~Home~PrivacyPolicy~TermOfService":"a622340a","Boyuk~Giganje":"417e7932","Boyuk":"6a062003","Giganje":"0f6009b7","Home":"0fd75f29","PrivacyPolicy":"50cf5120","TermOfService":"c89860ee","NotFound":"6d75dcd4","chunk-02c995b5":"45d315f4","chunk-09155df3":"e3ac211b","chunk-09162720":"102e7a40","chunk-097e0872":"dbc78691","chunk-0e93a01c":"b0a5975b","chunk-106fab1a":"fe76aac9","chunk-1bff95de":"ab2d4148","chunk-1dbc15a2":"8c41fb29","chunk-21a76241":"5ef9d983","chunk-25d83ca8":"6587c6be","chunk-2d0a463b":"9e69678c","chunk-2d0c073f":"017f6960","chunk-2d0d43da":"bc49aedb","chunk-2d0da04a":"620f425b","chunk-2d0e5812":"730e6176","chunk-2d213189":"2b11f265","chunk-2d217e6a":"9d5e5387","chunk-2d218068":"115cead1","chunk-2d21da73":"56e20878","chunk-2d2304d2":"e5c3a3b9","chunk-2d237b00":"037b5772","chunk-30dd9750":"6b7d6eb0","chunk-37f2300e":"cc3c45b7","chunk-3ed29de3":"9e68e146","chunk-41c0f7a4":"e0de4af1","chunk-462c869e":"ae6dddd3","chunk-47245a33":"b9e6a322","chunk-4739acd0":"18f7dcc3","chunk-485adc83":"99ebb2b4","chunk-53b1137a":"8970691a","chunk-541ea42d":"63c37d24","chunk-54bbd082":"dbfcec05","chunk-59d4c87c":"9a2960ba","chunk-5a8ac886":"c89483b8","chunk-5ff96a24":"515adcdf","chunk-69eb8776":"60866cb6","chunk-6d375f34":"3c78ca1c","chunk-7548ca2d":"18f11e7a","chunk-79f1dac7":"454e7c12","chunk-858cd918":"54b9acef","chunk-8bb7f81e":"4465b78a","chunk-a9395c36":"8777d2b5","chunk-d0e8aa0a":"ff130109","chunk-d8413eac":"e1c32b8b","chunk-e5275ddc":"f61bbd61","chunk-eaa2b130":"700c0fb3","polyfills-core-js":"12be3461","polyfills-dom":"662760da","chunk-2d2297f7":"78980670","chunk-2d2073d6":"9e36930f","chunk-2d0b33e3":"2e69defc","chunk-2d0b9280":"58416f48","chunk-2d0baac9":"ecbd8a2b","chunk-2d21a589":"a05685ae","chunk-2d2376e6":"a05b70ee"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Boyuk~Giganje~Home~PrivacyPolicy~TermOfService":1,"Boyuk~Giganje":1,"Boyuk":1,"Giganje":1,"Home":1,"PrivacyPolicy":1,"TermOfService":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Boyuk~Giganje~Home~PrivacyPolicy~TermOfService":"Boyuk~Giganje~Home~PrivacyPolicy~TermOfService","Boyuk~Giganje":"Boyuk~Giganje","Boyuk":"Boyuk","Giganje":"Giganje","Home":"Home","PrivacyPolicy":"PrivacyPolicy","TermOfService":"TermOfService","NotFound":"NotFound","polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom"}[chunkId]||chunkId) + "." + {"Boyuk~Giganje~Home~PrivacyPolicy~TermOfService":"8dae2206","Boyuk~Giganje":"df509c49","Boyuk":"84c21f41","Giganje":"e066f9b1","Home":"be1d06c2","PrivacyPolicy":"44496f5a","TermOfService":"f475fd15","NotFound":"31d6cfe0","chunk-02c995b5":"31d6cfe0","chunk-09155df3":"31d6cfe0","chunk-09162720":"31d6cfe0","chunk-097e0872":"31d6cfe0","chunk-0e93a01c":"31d6cfe0","chunk-106fab1a":"31d6cfe0","chunk-1bff95de":"31d6cfe0","chunk-1dbc15a2":"31d6cfe0","chunk-21a76241":"31d6cfe0","chunk-25d83ca8":"31d6cfe0","chunk-2d0a463b":"31d6cfe0","chunk-2d0c073f":"31d6cfe0","chunk-2d0d43da":"31d6cfe0","chunk-2d0da04a":"31d6cfe0","chunk-2d0e5812":"31d6cfe0","chunk-2d213189":"31d6cfe0","chunk-2d217e6a":"31d6cfe0","chunk-2d218068":"31d6cfe0","chunk-2d21da73":"31d6cfe0","chunk-2d2304d2":"31d6cfe0","chunk-2d237b00":"31d6cfe0","chunk-30dd9750":"31d6cfe0","chunk-37f2300e":"31d6cfe0","chunk-3ed29de3":"31d6cfe0","chunk-41c0f7a4":"31d6cfe0","chunk-462c869e":"31d6cfe0","chunk-47245a33":"31d6cfe0","chunk-4739acd0":"31d6cfe0","chunk-485adc83":"31d6cfe0","chunk-53b1137a":"31d6cfe0","chunk-541ea42d":"31d6cfe0","chunk-54bbd082":"31d6cfe0","chunk-59d4c87c":"31d6cfe0","chunk-5a8ac886":"31d6cfe0","chunk-5ff96a24":"31d6cfe0","chunk-69eb8776":"31d6cfe0","chunk-6d375f34":"31d6cfe0","chunk-7548ca2d":"31d6cfe0","chunk-79f1dac7":"31d6cfe0","chunk-858cd918":"31d6cfe0","chunk-8bb7f81e":"31d6cfe0","chunk-a9395c36":"31d6cfe0","chunk-d0e8aa0a":"31d6cfe0","chunk-d8413eac":"31d6cfe0","chunk-e5275ddc":"31d6cfe0","chunk-eaa2b130":"31d6cfe0","polyfills-core-js":"31d6cfe0","polyfills-dom":"31d6cfe0","chunk-2d2297f7":"31d6cfe0","chunk-2d2073d6":"31d6cfe0","chunk-2d0b33e3":"31d6cfe0","chunk-2d0b9280":"31d6cfe0","chunk-2d0baac9":"31d6cfe0","chunk-2d21a589":"31d6cfe0","chunk-2d2376e6":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
